import axios from 'axios';

// const BASE_URL = 'https://ubv-api-headrickleonard4090-mq070gq7.leapcell.dev/api/v1';
// const BASE_URL = 'http://localhost:3000/api/v1';
const BASE_URL = 'https://api.clurxsaify.io/api/v1';

// Create axios instance
const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Token management utilities
export const tokenManager = {
  setAuthToken: (token) => {
    localStorage.setItem('authToken', token);
  },
  
  getAuthToken: () => {
    return localStorage.getItem('authToken');
  },
  
  removeAuthToken: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
  },
  
  isAuthenticated: () => {
    return !!localStorage.getItem('authToken');
  },
  
  getUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },
  
  setUser: (user) => {
    localStorage.setItem('user', JSON.stringify(user));
  }
};

// Request interceptor to add auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = tokenManager.getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Only redirect to login for auth endpoints, not Schwab endpoints
    if (error.response?.status === 401 && !error.config.url.includes('/schwab')) {
      // Token expired or invalid
      tokenManager.removeAuthToken();
      window.location.href = '/ctshy-login';
      //0769829099
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: async (credentials) => {
    try {
      const response = await axios.post(`${BASE_URL}/auth/login`, credentials);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  logout: () => {
    tokenManager.removeAuthToken();
  },
  
  changePassword: async (currentPassword, newPassword) => {
    try {
      const response = await apiClient.put(
        `/auth/change-password`,
        { currentPassword, newPassword }
      );
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

// Media API
export const mediaAPI = {
  uploadMedia: async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await apiClient.post('/media/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

// Tiles API
export const tilesAPI = {
  getAllTiles: async () => {
    try {
      // Fetch up to 100 tiles instead of default 10
      const response = await apiClient.get('/tiles?limit=100');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  getTileById: async (id) => {
    try {
      const response = await apiClient.get(`/tiles/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  createTile: async (tileData) => {
    try {
      const response = await apiClient.post('/tiles', tileData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  updateTile: async (id, tileData) => {
    try {
      const response = await apiClient.put(`/tiles/${id}`, tileData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  deleteTile: async (id) => {
    try {
      const response = await apiClient.delete(`/tiles/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  reorderTiles: async (tiles) => {
    try {
      const response = await apiClient.put('/tiles/reorder', { tiles });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

// Schwab API
export const schwabAPI = {
  checkStatus: async () => {
    try {
      const response = await apiClient.get('/schwab/status');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  initiateAuth: async () => {
    try {
      const response = await apiClient.get('/schwab/auth');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  getPositions: async () => {
    try {
      const response = await apiClient.get('/schwab/positions');
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  },
  
  getQuotes: async (symbols) => {
    try {
      const response = await apiClient.get('/schwab/quotes', {
        params: { symbols: symbols.join(',') }
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
};

export default apiClient;